import React, { useState } from 'react'

import { twMerge } from 'tailwind-merge'

import AIPageContainer from 'src/components/AIAssistant/AIPageContainer'
import { Flex } from 'src/govwell-ui'
import { useCurrentBreakpoint } from 'src/hooks/use-current-breakpoint'
import AIChatSessions from 'src/pages/AIAssistantHistoryPage/AIChatSessions'
import ViewAIChatSession from 'src/pages/AIAssistantHistoryPage/ViewAIChatSession'

const AIAssistantHistoryPage = () => {
  const [selectedSessionId, setSelectedSessionId] = useState<number | null>(null)

  const openSession = (sessionId: number) => {
    setSelectedSessionId(sessionId)
  }

  const { isSmallScreen } = useCurrentBreakpoint()
  const small = isSmallScreen()

  return (
    <AIPageContainer
      title="Community Assistant History"
      subtitle="View conversation history and review Community Assistant interactions"
    >
      <Flex gap={6} direction={small ? 'column' : 'row'}>
        <div className={twMerge(small ? 'w-full' : 'w-1/2', 'h-full')}>
          <AIChatSessions onRowClick={openSession} activeSessionId={selectedSessionId} />
        </div>
        <div
          className={twMerge(
            `sticky top-2.5 h-[calc(100vh-64px)] self-start`,
            small ? 'w-full' : 'w-1/2'
          )}
        >
          {selectedSessionId && <ViewAIChatSession aiChatSessionId={selectedSessionId} />}
        </div>
      </Flex>
    </AIPageContainer>
  )
}

export default React.memo(AIAssistantHistoryPage)
